
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Inject, Injectable } from '@angular/core';
import { Observable, throwError } from 'rxjs';
import { environment } from '../../environments/environment'; 

@Injectable({
  providedIn: 'root',
})

export class DataService {
  private _ocpAPIMSubscriptionKey: string = environment.subKey;
  private _baseUrl: string;

  // Added to Support Azure APIM
  private _httpOptions = {
    headers: new HttpHeaders({
      'Ocp-Apim-Subscription-Key': this._ocpAPIMSubscriptionKey
    })
  };

  // Added to Support Azure APIM with File
  private _httpFileOptions = {
    headers: new HttpHeaders({
      'Ocp-Apim-Subscription-Key': this._ocpAPIMSubscriptionKey
    }), responseType: 'blob' as 'json'
  };

  constructor(private http: HttpClient, @Inject('BASE_URL') baseUrl: string) {
    this._baseUrl = baseUrl + "api/";
  }

  //return a get
  public get<T>(apiUrl: string, continuationToken: string | null = null): Observable<T> {
    if (continuationToken) {
      let httpOptions = {
        headers: new HttpHeaders({
          'Ocp-Apim-Subscription-Key': this._ocpAPIMSubscriptionKey,
          'Continuation-Token': continuationToken
        })
      };

      return this.http.get<T>(apiUrl, httpOptions);
    }

    return this.http.get<T>(apiUrl, this._httpOptions);
  }

  //return a get
  public getFile(apiUrl: string): Observable<any> {
    return this.http.get<any>(apiUrl, this._httpFileOptions);
  }

  //return a post
  public postFile(apiUrl: string, data: any): Observable<any> {
    return this.http.post<any>(apiUrl, data, this._httpFileOptions);
  }

  //return a get array
  public getMany<T>(apiUrl: string): Observable<T[]> {
    return this.http.get<T[]>(apiUrl, this._httpOptions);
  }

  //return a post 
  public post<T>(apiUrl: string, body: any): Observable<T> {
    return this.http.post<T>(apiUrl, body, this._httpOptions);
  }

  //return a put 
  public put<T>(apiUrl: string, body: any): Observable<T> {
    return this.http.put<T>(apiUrl, body, this._httpOptions);
  }

  //return a post array
  public postMany<T>(apiUrl: string, body: any): Observable<T[]> {
    return this.http.post<T[]>(apiUrl, body, this._httpOptions);
  }

  //return a delete 
  public delete<T>(apiUrl: string, body: any): Observable<T> {
    return this.http.delete<T>(apiUrl, this._httpOptions);
  }

  // Error handling 
  handleError(error) {
    let errorMessage = '';
    if (error.error instanceof ErrorEvent) {
      // Get client-side error
      errorMessage = error.error.message;
    } else {
      // Get server-side error
      errorMessage = `Error Code: ${error.status}\nMessage: ${error.message}`;
    }
    window.alert(errorMessage);
    return throwError(errorMessage);
  }
}
